var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionPageYellowSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 142,
    viewBox: "0 0 139 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.895 71.3704C106.895 92.0119 90.1357 108.771 69.4942 108.771C48.8527 108.771 32.0938 92.0119 32.0938 71.3704C32.0938 50.7289 48.8527 33.97 69.4942 33.97C90.1357 33.97 106.895 50.7289 106.895 71.3704Z",
    fill: "#FFC557"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3047 26.7938L69.4971 0.844482L75.6404 26.7938H63.3047Z",
    fill: "#FFC557"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4025 31.6098L45.3555 5.11993L60.0011 27.3833L48.4025 31.6098Z",
    fill: "#FFC557"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0832 41.1918L24.1406 17.3558L45.5193 33.2793L36.0832 41.1918Z",
    fill: "#FFC557"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.766 54.4155L8.40234 36.1331L33.9585 43.7507L27.766 54.4155Z",
    fill: "#FFC557"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4749 69.6985L0 59.132L26.6374 57.5593L24.4749 69.6985Z",
    fill: "#FFC557"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6374 85.1794L0 83.6559L24.4749 73.0894L26.6374 85.1794Z",
    fill: "#FFC557"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9093 99.039L8.40234 106.657L27.766 88.3743L33.9093 99.039Z",
    fill: "#FFC557"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5193 109.506L24.1406 125.43L36.0832 101.594L45.5193 109.506Z",
    fill: "#FFC557"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0011 115.405L45.3555 137.668L48.4025 111.178L60.0011 115.405Z",
    fill: "#FFC557"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6404 115.996L69.4971 141.946L63.3047 115.996H75.6404Z",
    fill: "#FFC557"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5282 111.178L93.6245 137.668L78.9297 115.405L90.5282 111.178Z",
    fill: "#FFC557"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.878 101.594L114.82 125.43L93.4414 109.506L102.878 101.594Z",
    fill: "#FFC557"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.178 88.3743L130.591 106.657L105.035 99.039L111.178 88.3743Z",
    fill: "#FFC557"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.465 73.0895L138.94 83.656L112.352 85.2286L114.465 73.0895Z",
    fill: "#FFC557"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.352 57.5593L138.94 59.132L114.465 69.6985L112.352 57.5593Z",
    fill: "#FFC557"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.035 43.7507L130.591 36.1331L111.178 54.4155L105.035 43.7507Z",
    fill: "#FFC557"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4414 33.2792L114.82 17.3557L102.878 41.1917L93.4414 33.2792Z",
    fill: "#FFC557"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9297 27.3821L93.6245 5.06964L90.5282 31.6087L78.9297 27.3821Z",
    fill: "#FFC557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPageYellowSun);
export default __webpack_public_path__ + "static/media/SubscriptionPageYellowSun.377530ff0ba6335821764a4dbe446a65.svg";
export { ForwardRef as ReactComponent };